import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableHead, TableRow} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import annualReportSteps from "../../constants/annualReportSteps";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportNotIncludedEditForm from "./AnnualReportNotIncludedEditForm";
import AnnualReportNotIncludedTablePart from "./AnnualReportNotIncludedTablePart";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";

const reportStep = annualReportSteps.notIncluded;

function AnnualReportNotIncludedForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict} = useContext(FormTranslationContext);
    const [types] = useState(getDict("SL.MMiA.064"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    if (!initValues) return <Loading/>
    return (<>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableCell borderLeft>
                        <div>{Tr("column_lp")}</div>
                    </AnnualReportTableCell>
                    <AnnualReportTableHeadCell label="mmia.notIncluded.type" colSpan={2}/>
                    <AnnualReportTableHeadCell label="mmia.notIncluded.contractValue"/>
                    <AnnualReportTableCell borderRight borderLeft/>
                </TableRow>

                {
                    types.map((type) =>
                        <AnnualReportNotIncludedTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            reportStep={reportStep}
                        />
                    )
                }
            </TableHead>
        </Table>
        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={reportStep}
                FormComponent={AnnualReportNotIncludedEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType).map((item) => ({
                    label: item.value + " - " + item.label,
                    value: item.value
                }))}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }

    </>)


}

AnnualReportNotIncludedForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportNotIncludedForm;